import { SubmissionError } from 'redux-form';
import { PROJECTS_TAG } from '../../../../data/actions';
import { getProjectConditions } from '../projectActions';

export const SET_ACTIVE_PROJECT_SIGNALS = 'SET_ACTIVE_PROJECT_SIGNALS';
export const SET_ACTIVE_PROJECT_EVENTS = 'SET_ACTIVE_PROJECT_EVENTS';
export const SET_ACTIVE_PROJECT_STIMULI = 'SET_ACTIVE_PROJECT_STIMULI';
export const SET_ACTIVE_PROJECT_TRANSFORMATIONS = 'SET_ACTIVE_PROJECT_TRANSFORMATIONS';
export const SET_ACTIVE_PROJECT_SELECTED_TRANSFORMATIONS =
  'SET_ACTIVE_PROJECT_SELECTED_TRANSFORMATIONS';

export const EVENTS_TAG = 'Events';
export const STIMULI_TAG = 'Stimuli';
export const SIGNALS_TAG = 'Signals';
export const TRANSFORMATION_TAG = 'Transformation';

/**
 * Reducer Actions
 */

const setActiveProjectSignals = signals => {
  return {
    type: SET_ACTIVE_PROJECT_SIGNALS,
    signals
  };
};

const setActiveProjectEvents = events => {
  return {
    type: SET_ACTIVE_PROJECT_EVENTS,
    events
  };
};

const setActiveProjectStimuli = stimuli => {
  return {
    type: SET_ACTIVE_PROJECT_STIMULI,
    stimuli
  };
};
const setActiveProjectTransformations = transformation => {
  return {
    type: SET_ACTIVE_PROJECT_TRANSFORMATIONS,
    transformation
  };
};

const setActiveProjectSelectedTransformations = selectedTransformation => {
  return {
    type: SET_ACTIVE_PROJECT_SELECTED_TRANSFORMATIONS,
    selectedTransformation
  };
};

export const invalidateOccurrences = () => {
  return dispatch => {
    dispatch(setActiveProjectSignals(null));
    dispatch(setActiveProjectEvents(null));
    dispatch(setActiveProjectTransformations(null));
    dispatch(setActiveProjectSelectedTransformations(null));
    dispatch(setActiveProjectStimuli(null));
  };
};

/**
 * General Occurrence Lister
 * @param operationId
 * @param projectId
 * @param setOccurrencesForActiveProject
 * @returns {Function}
 */
const getOccurrences = (operationId, projectId, setOccurrencesForActiveProject) => {
  return async (dispatch, getState, { apiClient }) => {
    const results = await apiClient.call(PROJECTS_TAG, operationId, { projectId, $limit: 1500 });
    console.log(operationId, results);
    dispatch(setOccurrencesForActiveProject(results.data));
    return true;
  };
};

/**
 * Create an Occurrence
 * @param occurrence
 * @param tag
 * @param operationId
 * @param projectId
 * @param getOccurrencesForProject
 * @param callback
 * @returns {function(*, *, *): boolean}
 */
const createOccurrence = (
  occurrence,
  tag,
  operationId,
  projectId,
  getOccurrencesForProject,
  callback
) => {
  return async (dispatch, getState, { apiClient }) => {
    const createdOccurrence = await apiClient.call(tag, operationId, {}, occurrence);

    await apiClient.call(
      PROJECTS_TAG,
      `associateProject${tag}`,
      { projectId },
      {
        id: createdOccurrence.id,
        software_id: occurrence.software_id,
        version_id: occurrence.version_id
      }
    );

    dispatch(getOccurrencesForProject(projectId));
    callback && callback(createdOccurrence);
    return true;
  };
};

/**
 * Update an Occurrence
 * @param occurrence
 * @param tag
 * @param operationId
 * @param projectId
 * @param getOccurrencesForProject
 * @param callback
 * @returns {function(*, *, *): boolean}
 */
const updateOccurrenceDataAcquisition = (
  occurrence,
  tag,
  projectId,
  getOccurrencesForProject,
  callback
) => {
  return async (dispatch, getState, { apiClient }) => {
    const occurrenceId = await apiClient.call(
      PROJECTS_TAG,
      `updateProject${tag}`,
      { projectId, id: occurrence.id },
      occurrence
    );

    dispatch(getOccurrencesForProject(projectId));
    callback && callback(occurrenceId);
    return true;
  };
};

/**
 * General Occurrence Delete
 * @param occurrenceId
 * @param tag
 * @param operationId
 * @param projectId
 * @param getOccurrencesForProject
 * @param callback
 * @returns {function(*, *, *): boolean}
 */
const deleteOccurrence = (
  occurrenceId,
  tag,
  operationId,
  projectId,
  getOccurrencesForProject,
  callback
) => {
  return async (dispatch, getState, { apiClient }) => {
    await apiClient.call(PROJECTS_TAG, `removeProject${tag}`, { projectId, id: occurrenceId });
    dispatch(getOccurrencesForProject(projectId));
    dispatch(getProjectConditions(projectId));

    callback && callback();
    return true;
  };
};

/**
 * Signals
 */

export const getSignalsForProject = projectId => {
  return getOccurrences('getProjectSignals', projectId, setActiveProjectSignals);
};

export const getTransformationsForProject = projectId => {
  return getOccurrences(
    'getProjectTransformationsAvailable',
    projectId,
    setActiveProjectTransformations
  ); // TODO: TRANSFORMATIONS
};

export const getSelectedTransformationsForProject = projectId => {
  return getOccurrences(
    'getProjectTransformations',
    projectId,
    setActiveProjectSelectedTransformations
  ); // TODO: TRANSFORMATIONS
};

const signalHasDimensions = signal => {
  if (signal.dimensions.length === 0) {
    throw new SubmissionError({
      dimensions: 'At least one dimension must be selected.'
    });
  }
};

export const createSignalForProject = (occurrence, projectId, callback) => {
  signalHasDimensions(occurrence);
  return async (dispatch, getState, { apiClient }) => {
    const signals = await apiClient.call(
      PROJECTS_TAG,
      'associateProjectSignals',
      { projectId },
      occurrence
    );

    dispatch(getSignalsForProject(projectId));
    dispatch(getTransformationsForProject(projectId));
    callback && callback(signals);
    return true;
  };
};

export const updateSignalForProject = (occurrence, projectId, callback) => {
  signalHasDimensions(occurrence);
  return updateOccurrenceDataAcquisition(
    occurrence,
    SIGNALS_TAG,
    projectId,
    getSignalsForProject,
    callback
  );
};

export const deleteSignal = (id, projectId, versionId, callback) => {
  return async (dispatch, getState, { apiClient }) => {
    await apiClient.call(PROJECTS_TAG, `removeProject${SIGNALS_TAG}`, { projectId, id, versionId });

    dispatch(getSignalsForProject(projectId));
    dispatch(getProjectConditions(projectId));
    dispatch(getTransformationsForProject(projectId));
    callback && callback();
    return true;
  };
};

/**
 * Events
 */
export const getEventsForProject = projectId => {
  return getOccurrences('getProjectEvents', projectId, setActiveProjectEvents);
};

export const createEventForProject = (occurrence, projectId, callback) => {
  return createOccurrence(
    occurrence,
    EVENTS_TAG,
    'createEvent',
    projectId,
    getEventsForProject,
    callback
  );
};

export const updateEventForProject = (occurrence, projectId, callback) => {
  return updateOccurrenceDataAcquisition(
    occurrence,
    EVENTS_TAG,
    projectId,
    getEventsForProject,
    callback
  );
};

export const deleteEvent = (id, projectId, callback) => {
  return deleteOccurrence(id, EVENTS_TAG, 'deleteEvent', projectId, getEventsForProject, callback);
};

// TODO: TRANSFORMATIONS
export const createTransformationForProject = (transformationId, projectId, callback) => {
  return async (dispatch, getState, { apiClient }) => {
    const transformations = await apiClient.call(
      PROJECTS_TAG,
      'associateProjectTransformations',
      { projectId },
      transformationId
    );

    dispatch(getTransformationsForProject(projectId));
    dispatch(getSelectedTransformationsForProject(projectId));
    callback && callback(transformations);
    return true;
  };
};

export const updateTransformationForProject = (occurrence, projectId, callback) => {
  return updateOccurrenceDataAcquisition(
    occurrence,
    TRANSFORMATION_TAG,
    projectId,
    getTransformationsForProject,
    callback
  );
};

export const deleteTransformation = (id, projectId, callback) => {
  return async (dispatch, getState, { apiClient }) => {
    await apiClient.call(PROJECTS_TAG, `removeProjectTransformations`, { projectId, id });

    dispatch(getTransformationsForProject(projectId));
    dispatch(getSelectedTransformationsForProject(projectId));
    dispatch(getProjectConditions(projectId));

    callback && callback();
    return true;
  };
};
/**
 * Stimuli
 */
export const getStimuliForProject = projectId => {
  return getOccurrences('getProjectStimuli', projectId, setActiveProjectStimuli);
};

export const createStimuliForProject = (occurrence, projectId, callback) => {
  if (occurrence.file) {
    occurrence.file_extension = occurrence.file.name.slice(
      ((occurrence.file.name.lastIndexOf('.') - 1) >>> 0) + 2 // eslint-disable-line no-bitwise
    );
  }

  occurrence.start_marker = 'stimuli';
  occurrence.end_marker = 'stimuli';

  return createOccurrence(
    occurrence,
    STIMULI_TAG,
    'createStimuli',
    projectId,
    getStimuliForProject,
    callback
  );
};

export const updateStimuliForProject = (occurrence, projectId, callback) => {
  return updateOccurrenceDataAcquisition(
    occurrence,
    STIMULI_TAG,
    projectId,
    getStimuliForProject,
    callback
  );
};

export const deleteStimuli = (id, projectId, callback) => {
  return deleteOccurrence(
    id,
    STIMULI_TAG,
    'deleteStimuli',
    projectId,
    getStimuliForProject,
    callback
  );
};



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/data/experimentalDesign/occurrenceActions.js